/**
 * Vantage Heritage — Animation Engine
 * Scroll reveals, parallax, page transitions, 3D hover
 */

(function() {
  'use strict';

  /* ==========================================
     1. SCROLL REVEAL (Intersection Observer)
     ========================================== */
  function initScrollReveal() {
    // Auto-tag sections for reveal
    const revealTargets = [
      'section',
      '.hero-split__text',
      '.hero-split__images',
      '.featured-carousel',
      '.collection-list',
      '.newsletter',
      '.footer',
      '.title-wrapper',
      '.card-wrapper',
      '.card'
    ];

    revealTargets.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (!el.classList.contains('scroll-reveal') && !el.closest('.header-group') && !el.closest('header')) {
          el.classList.add('scroll-reveal');
        }
      });
    });

    // Stagger product/collection cards within their parent
    document.querySelectorAll('.grid, .collection-list__grid, .swiper-wrapper').forEach(function(grid) {
      var cards = grid.querySelectorAll('.card-wrapper, .card, .swiper-slide, .grid__item');
      cards.forEach(function(card, i) {
        card.style.transitionDelay = (i * 0.1) + 's';
      });
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Don't unobserve — allows re-animation if needed
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -60px 0px'
    });

    document.querySelectorAll('.scroll-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ==========================================
     2. PARALLAX HERO
     ========================================== */
  function initParallax() {
    var hero = document.querySelector('.hero-split');
    if (!hero) return;

    var cards = hero.querySelectorAll('.hero-split__card');
    var textSection = hero.querySelector('.hero-split__text');
    var speeds = [0.15, 0.25, 0.35, 0.2, 0.3];

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.scrollY;
          var heroRect = hero.getBoundingClientRect();

          // Only animate when hero is in view
          if (heroRect.bottom > 0 && heroRect.top < window.innerHeight) {
            cards.forEach(function(card, i) {
              var speed = speeds[i] || 0.2;
              card.style.transform = 'translateY(' + (scrollY * speed * -1) + 'px)';
            });

            if (textSection) {
              textSection.style.transform = 'translateY(' + (scrollY * 0.05) + 'px)';
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ==========================================
     3. PAGE TRANSITIONS
     ========================================== */
  function initPageTransitions() {
    // Use View Transitions API if available
    if (!document.startViewTransition) {
      // Fallback: CSS-based transitions
      document.body.classList.add('page-loaded');

      document.addEventListener('click', function(e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');

        // Only internal links, skip anchors/external/special
        if (!href || href.startsWith('#') || href.startsWith('http') || href.startsWith('mailto') ||
            href.startsWith('tel') || link.target === '_blank' || e.ctrlKey || e.metaKey) return;

        e.preventDefault();
        document.body.classList.add('page-exiting');

        setTimeout(function() {
          window.location.href = href;
        }, 350);
      });

      return;
    }

    // Modern View Transitions API
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');

      if (!href || href.startsWith('#') || href.startsWith('http') || href.startsWith('mailto') ||
          href.startsWith('tel') || link.target === '_blank' || e.ctrlKey || e.metaKey) return;

      e.preventDefault();
      document.startViewTransition(function() {
        window.location.href = href;
      });
    });
  }

  /* ==========================================
     4. 3D HOVER TILT ON CARDS
     ========================================== */
  function initCardTilt() {
    document.querySelectorAll('.card, .hero-split__card').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;

        var rotateX = ((y - centerY) / centerY) * -4;
        var rotateY = ((x - centerX) / centerX) * 4;

        card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
      });

      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
        card.style.transition = 'transform 0.4s ease';
        setTimeout(function() { card.style.transition = ''; }, 400);
      });
    });
  }

  /* ==========================================
     5. COUNTER ANIMATION (for stats if any)
     ========================================== */
  function initCounters() {
    document.querySelectorAll('[data-count]').forEach(function(el) {
      var target = parseInt(el.dataset.count, 10);
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          animateCount(el, 0, target, 1500);
          observer.disconnect();
        }
      });
      observer.observe(el);
    });
  }

  function animateCount(el, start, end, duration) {
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * (end - start) + start);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ==========================================
     6. SWIPER 3D CAROUSEL INIT
     ========================================== */
  function initCarousel() {
    var carouselEl = document.querySelector('.featured-carousel__swiper');
    if (!carouselEl || typeof Swiper === 'undefined') return;

    new Swiper(carouselEl, {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      speed: 600,
      autoplay: {
        delay: parseInt(carouselEl.dataset.autoplay || '4000', 10),
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      coverflowEffect: {
        rotate: 4,
        stretch: 0,
        depth: 120,
        modifier: 1.5,
        slideShadows: false
      },
      pagination: {
        el: '.featured-carousel__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.featured-carousel__next',
        prevEl: '.featured-carousel__prev'
      },
      breakpoints: {
        320: { slidesPerView: 1.2 },
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1400: { slidesPerView: 3.5 }
      }
    });
  }

  /* ==========================================
     7. MAGNETIC CURSOR ON BUTTONS
     ========================================== */
  function initMagneticButtons() {
    document.querySelectorAll('.hero-split__btn, .button').forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = '';
      });
    });
  }

  /* ==========================================
     INIT ALL
     ========================================== */
  function init() {
    initScrollReveal();
    initParallax();
    initPageTransitions();
    initCardTilt();
    initCounters();
    initMagneticButtons();

    // Swiper may load async — retry if not ready
    if (typeof Swiper !== 'undefined') {
      initCarousel();
    } else {
      var checkSwiper = setInterval(function() {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          initCarousel();
        }
      }, 200);
      setTimeout(function() { clearInterval(checkSwiper); }, 5000);
    }

    // Mark page as loaded for entry animation
    requestAnimationFrame(function() {
      document.body.classList.add('page-loaded');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
